export enum Currency {
  EUR = "EUR",
  GBP = "GBP",
  USD = "USD"
}

function formatNumber(val: number, n: number, x: number) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return val.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}

export function currencySymbol(currency: Currency): string {
  switch (currency) {
    case Currency.USD:
      return '$'
    case Currency.GBP:
      return '£'
    default:
    case Currency.EUR:
      return '€'
  }
}

export function formatCurrency(price: number, currency: Currency, dp: number = 2): string {
  const symbol = currencySymbol(currency)
  return `${symbol}${formatNumber(price || 0, dp, 3)}`
}